import GameVersion from 'app/frontend/types/custom/GameVersion'

export type RawBullet = string | { text: string; versions?: GameVersion[] }

export const visibleBullets = (
  raw: RawBullet[],
  gameVersion: GameVersion,
): string[] =>
  raw
    .filter(
      (bullet) =>
        typeof bullet === 'string' ||
        !bullet.versions ||
        bullet.versions.includes(gameVersion),
    )
    .map((bullet) => (typeof bullet === 'string' ? bullet : bullet.text))
